module.exports = __webpack_public_path__ + "fonts/remixicon.dc0fb3e9.eot";